import AjaxForm from '@naturehouse/design-system/components/organisms/form/AjaxForm';
import parseStringAsHtml from '@naturehouse/nh-essentials/lib/html/parser';
import GTM from '../../../gtm/GTM';
import GTMNewsletterSignupModel from '../../../gtm/models/GTMNewsletterSignupModel';

export default class NewsletterForm extends AjaxForm {
    protected onSuccess(): void {
        const succesMessageElement: HTMLElement | null =
            this.parentElement?.querySelector('.notification--success') ?? null;

        if (succesMessageElement) {
            succesMessageElement.hidden = false;
            this.hidden = true;
        }

        const formData = new FormData(this);
        const email = formData.get('newsletter_subscriber_form[emailAddress]') as string;
        this.#trackNewsletterSubscription(email);
    }

    protected onError(error: Error): void {
        const errorList = parseStringAsHtml(
            `
            <ul class="error-list">
                <li class="error">${error.message}</li>
            </ul>
        `,
            'ul'
        ) as HTMLUListElement;
        this.insertBefore(errorList, this.firstChild);
    }

    async #trackNewsletterSubscription(email: string): Promise<void> {
        GTM.track(await GTMNewsletterSignupModel.parseToGTMData({ email }));
    }
}

if (!customElements.get('newsletter-form')) {
    customElements.define('newsletter-form', NewsletterForm, { extends: 'form' });
}
